module.exports = __webpack_public_path__ + "img/sos-type-black.265d5da6.png";